<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.902"
    height="20.012"
    viewBox="0 0 19.902 20.012"
  >
    <path
      d="M15.71,12.71a6,6,0,1,0-7.42,0,10,10,0,0,0-6.22,8.18,1.006,1.006,0,1,0,2,.22,8,8,0,0,1,15.9,0,1,1,0,0,0,1,.89h.11a1,1,0,0,0,.88-1.1,10,10,0,0,0-6.25-8.19ZM12,12a4,4,0,1,1,4-4A4,4,0,0,1,12,12Z"
      transform="translate(-2.064 -1.995)"
    />
  </svg>
</template>
<script>
export default {
  name: 'ProfileIcon',
};
</script>
